module.exports = __webpack_public_path__ + "assets/6faf1a65c2adb8e0784e2eccc51aaf8a.png";